import { default as brokerKaG5Mni9vaMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/broker.vue?macro=true";
import { default as doplnenie_45udajovRI1HKB8QrPMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/doplnenie-udajov.vue?macro=true";
import { default as doplnenie5Ph7dQEhZmMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/doplnenie.vue?macro=true";
import { default as fotodokumentacia2aA5et4lfSMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/fotodokumentacia.vue?macro=true";
import { default as kalkulaciewkPTzbEuAkMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/kalkulacie.vue?macro=true";
import { default as platbaf6zPwTsQb7Meta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/platba.vue?macro=true";
import { default as ponukyiSRFwInkbCMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/ponuky.vue?macro=true";
import { default as rekapitulaciak6qFeyBUecMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/rekapitulacia.vue?macro=true";
import { default as upsell1kNLKNCPSvMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/upsell.vue?macro=true";
import { default as vyrocieME1FkECIHgMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/vyrocie.vue?macro=true";
import { default as zavolajteminAFkvKImnaMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/zavolajtemi.vue?macro=true";
import { default as pageBy5xYksM6SMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testkGFKvuI0kiMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepageMTfLRX50COMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articleHj2QHQjGGcMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternspTkshRwOLiMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagzhlTKSDR51Meta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autor8iIHcA0z0RMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as categoryKtpSuCzkNaMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectionYq8Ji92ISMMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articlesHr1uuRRYhoMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categoryR0BrMnyNF7Meta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articler1syTmj7kcMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as section9V6smeFV43Meta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as poistenie_45zivot_45uniqanUytN3cE5rMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/poistenie-zivot-uniqa?macro=true";
import { default as odhlasenie_45z_45mailingukZU7J2ZDV1Meta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/odhlasenie-z-mailingu?macro=true";
import { default as complaintKCdhFymcJCMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/complaint?macro=true";
import { default as contactgKP66LAJYiMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45terminationSefyqXMWRTMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as zadost1D7Lx2NHLiMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankgYJouKpSDjMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnanishoyCiqKLAMeta } from "/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
export default [
  {
    name: "autopoistenie-broker",
    path: "/autopoistenie/broker",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/broker.vue")
  },
  {
    name: "autopoistenie-doplnenie-udajov",
    path: "/autopoistenie/doplnenie-udajov",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/doplnenie-udajov.vue")
  },
  {
    name: "autopoistenie-doplnenie",
    path: "/autopoistenie/doplnenie",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/doplnenie.vue")
  },
  {
    name: "autopoistenie-fotodokumentacia",
    path: "/autopoistenie/fotodokumentacia",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/fotodokumentacia.vue")
  },
  {
    name: "autopoistenie-kalkulacie",
    path: "/autopoistenie/kalkulacie",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/kalkulacie.vue")
  },
  {
    name: "autopoistenie-platba",
    path: "/autopoistenie/platba",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/platba.vue")
  },
  {
    name: "autopoistenie-ponuky",
    path: "/autopoistenie/ponuky",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/ponuky.vue")
  },
  {
    name: "autopoistenie-rekapitulacia",
    path: "/autopoistenie/rekapitulacia",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/rekapitulacia.vue")
  },
  {
    name: "autopoistenie-upsell",
    path: "/autopoistenie/upsell",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/upsell.vue")
  },
  {
    name: "autopoistenie-vyrocie",
    path: "/autopoistenie/vyrocie",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/vyrocie.vue")
  },
  {
    name: "autopoistenie-zavolajtemi",
    path: "/autopoistenie/zavolajtemi",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/zavolajtemi.vue")
  },
  {
    name: pageBy5xYksM6SMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testkGFKvuI0kiMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepageMTfLRX50COMeta?.name,
    path: "/magazin",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articleHj2QHQjGGcMeta?.name,
    path: "/magazin/:article(.*)*",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternspTkshRwOLiMeta?.name,
    path: "/magazin/vzory-dokumentov",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagzhlTKSDR51Meta?.name,
    path: "/magazin/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autor8iIHcA0z0RMeta?.name,
    path: "/magazin/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: categoryKtpSuCzkNaMeta?.name,
    path: "/magazin/:category(poistenie|financie)",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectionYq8Ji92ISMMeta?.name,
    path: "/magazin/:category(poistenie|financie)/:section(cestovanie|zivot|dom-a-domacnost|auto|pozicky-a-uvery)",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articlesHr1uuRRYhoMeta?.name,
    path: "/magazin/all-articles",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pageBy5xYksM6SMeta?.name,
    path: "/slovnik-pojmov",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categoryR0BrMnyNF7Meta?.name,
    path: "/slovnik-pojmov/:category(poistenie)",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articler1syTmj7kcMeta?.name,
    path: "/slovnik-pojmov/:category(poistenie)/:id(.*)*",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: section9V6smeFV43Meta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: section9V6smeFV43Meta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: poistenie_45zivot_45uniqanUytN3cE5rMeta?.name,
    path: "/poistenie-zivot-uniqa",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/poistenie-zivot-uniqa")
  },
  {
    name: odhlasenie_45z_45mailingukZU7J2ZDV1Meta?.name,
    path: "/odhlasenie-z-mailingu",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/odhlasenie-z-mailingu")
  },
  {
    name: complaintKCdhFymcJCMeta?.name,
    path: "/reklamacie",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/complaint")
  },
  {
    name: contactgKP66LAJYiMeta?.name,
    path: "/kontakty",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45terminationSefyqXMWRTMeta?.name,
    path: "/poistenie/zmena-poistovne-autopoistenie",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: zadost1D7Lx2NHLiMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka)/zadost",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankgYJouKpSDjMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnanishoyCiqKLAMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src3624123827/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  }
]